import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from 'prop-types';

import Cookies from "js-cookie";


const ProtectedRoute = ({ component: Component, ...rest }) => {
  const token = Cookies.get("token"); // Get token from localStorage
  // If token is not available, redirect to login page
  if (!token) {
    return <Navigate to="/authentication/sign-in" />;
  }

  // Optionally validate the token with an API call here

  // Render the protected component
  return <Component {...rest} />;
};
ProtectedRoute.propTypes = {
    component: PropTypes.elementType.isRequired, // Component should be a React component
  };
  
export default ProtectedRoute;